import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CloseIcon from '@mui/icons-material/Close';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { IconButton, Stack, TextField } from "@mui/material";
import WBTextField from "components/input/WBTextField";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import useFetch from "services/hooks/useFetch";
import { getCookie } from "services/utils/CookieHandler";
import { ApiUrls } from "services/utils/globalVariables";
import ChatVoiceRecorder from "./Recorder/ChatVoiceRecorder";

//main logic for chat submitting
//Sending : Text
//Recording : Voice
//Attaching : Files
//Don't judge me Im high :DDD

//this component will act as sending the data from user to chat

//Style for input
const inputStyle = {
    background: "white",
    border: "none !important",
    borderRadius: "24px",
    width: "100%",
    outline: "none",
    "& fieldset": {
        border: "none !important",
        outline: "none !important",
        "&:focus": {
            outline: "none !important",
            border: "none !important"
        }
    },
    "& .MuiInputBase-input": {
        fontSize: "14px !important"
    }
}

export default function ChatSubmissionForm({ connection, currentId, setData, data, setloader }) {

    //Uploading attachment API
    const [{response, isLoading, error}, doFetchUpload] = useFetch(ApiUrls.UploadAttachment, "post", false, true)

    // Value == the value of message | Type == type of message (signed below) | File == current attached file
    const [value, setValue] = useState("")
    const [type, setType] = useState(0)
    const [file, setFile] = useState(undefined)
    const [seenFlag, setSeenFlag] = useState(false)

    const latestData = useRef(null)

    const fileRef = useRef()

    const loginInfo = getCookie("loginData")

    const { handleSubmit, control, reset, formState: {errors} } = useForm();

    // types for attachment :
    // 0 ====> string (message)
    // 1 ====> string (voice)
    // 2 ====> string (photo)
    // 3 ====> string (video)
    // 4 ====> string (miscs)

    latestData.current = data

    //connection handling useEffect
    useEffect(() => {
        let flag = true

        if(connection) {
            connection.on('MessagesChat', (res) => {
                seenMessageOnLoad(res.data)
            })

            //refreshing message chat to loading new chat
            connection.on("RefreshMessagesChat", (res) => {
                if(flag && currentId == JSON.parse(res).Data.TicketId) {
                    const updatedChat = [...latestData.current];
                    updatedChat.push(JSON.parse(res).Data);
                    setData(updatedChat)

                    seenMessage([JSON.parse(res).Data])

                    setTimeout(() => {
                        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
                    }, 1000);
                }
            })

            //when seen happens
            connection.on('SeenMessage', (res) => {
                const updatedChat = [...latestData.current].reverse();
                updatedChat.find(function (item, index) {
                    if (res.includes(item.Id)) {
                        updatedChat[index].IsSeen = true
                    }
                })
                setData(updatedChat.reverse())
            })
        }

        return (() => {
            flag = false
        })

    }, [connection])

    // ============================== Submitting and sending ============================== //

    //Submitting message
    const handleSubmitData = (data) => {
        if(connection && loginInfo) {
            //First if we have attach then call message API (SignalR)
            handleSendFile((res) => handleSendMessage(data, res))
        }
    }

    //Changing value for showing send button
    const handleChangeValue = (event) => {
        setValue(event.target.value)
    }

    //Main sending system (message just text) attach and recording handled with attachment system
    const handleSendMessage = (data, res, audioType) => {
        setloader(true)
        connection.send(
            "SendMessage",
            currentId,
            (!audioType || type == 0 ? data?.Message : ""),
            (audioType ? audioType : type),
            ((audioType ? audioType : type), audioType || type != 0 ? res.Data.Url : ""),
            loginInfo.userId,
            loginInfo.accessToken
        )

        //Reset input for next message
        handleResetData()
        //Timeout for scrolling to bottom after sending a message
        setTimeout(() => {
            setloader(false)
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        }, 300);
    }

    // ============================== Attachment System ============================== //

    //Adding a file to stage (form)
    const handleAddFile = (event) => {
        setFile(event.target.files)

        reset((defVal) => {return {
            ...defVal,
            Message: event.target.files[0].name
        }})
        setValue(event.target.files[0].name)
    }

    //Sending file to API (server)
    const handleSendFile = (handleCallback) => {
        setloader(true)
        if(type != 0) {
            const uploadData = new FormData()
            uploadData.append('attachment', file[0]);
            uploadData.append('messageType', type);

            reset({
                Message: ""
            })
            setType(0)
            setValue("")
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);

            doFetchUpload(uploadData, handleCallback)
        } else {
            handleCallback()
        }
    }

    //Reseting after sending a message
    const handleResetData = () => {
        reset({
            Message: ""
        })
        setType(0)
        setValue("")
        setFile(undefined)
        fileRef.current.value = ""
    }

    //Set type to 4 when clicked on attachment icon
    const handleClickAttachment = () => {
        fileRef.current.click()
        setType(4)
    }

    const handleSendVoice = (blob) => {
        if(blob) {
            setloader(true)
            let recordFile = new File([blob], "recordfile")

            const uploadData = new FormData()
            uploadData.append('attachment', recordFile);
            uploadData.append('messageType', 1);

            doFetchUpload(uploadData, (res) => handleSendMessage(null, res, 1))
        }
    }

    // ============================== Seen System ============================== //

    //Seen system function for messages on load
    const seenMessageOnLoad = (data) => {
        let list = []
        let userId;

        data.map(function (item) {
            if (item.CreatedUserId != loginInfo.userId && !item.IsSeen && currentId == data[0].TicketId) {
                list.push(item.Id)
                userId = item.CreatedUserId
            }
        })

        if (list.length) {
            connection.send("SeenMessage", list, currentId, loginInfo.userId, loginInfo.accessToken)
        }
    }

    const seenMessage = (data) => {
        connection.send("SeenMessage", [data[0].Id], currentId, loginInfo.userId, loginInfo.accessToken);
    }

    return (
        <Stack component="form" onSubmit={handleSubmit(handleSubmitData)} direction="row" spacing={1}>
            <Stack direction="row" spacing={1}>
                {
                    value != "" ?
                    <>
                        <IconButton size="small" type="submit">
                            <SendOutlinedIcon sx={{color: "white"}} />
                        </IconButton>
                        {
                            file &&
                            <IconButton size="small" onClick={handleResetData}>
                                <CloseIcon sx={{color: "white"}} />
                            </IconButton>
                        }
                    </>
                    :
                    <>
                        <ChatVoiceRecorder sendVoice={handleSendVoice} />
                        <IconButton size="small" onClick={handleClickAttachment}>
                            <AttachFileOutlinedIcon sx={{color: "white"}} />
                        </IconButton>
                    </>
                }
            </Stack>
            <WBTextField
                control={control}
                name="Message"
                innerFunction={handleChangeValue}
                placeholder="متن پیام ..."
                multiline
                size="small"
                sx={inputStyle}
                disabled={value && file ? true : false}
            />
            <TextField
                type="file"
                onChange={handleAddFile}
                sx={{display: "none !important"}}
                inputProps={{
                    ref: fileRef
                }}
            />
        </Stack>
    )
}